/**
 * 通用空状态组件（内联 SVG 矢量图，无需外部图片资源）
 *
 * 使用场景：列表/轮播等区域加载完成但无数据时展示。
 * 用内联 SVG 而非字体图标或图片，好处是：
 *   - 不依赖 remixicon 字体加载，弱网/字体加载失败时依然完整显示
 *   - 矢量，任意尺寸不失真
 *   - 可随尺寸自动缩放（width/height 由 size 控制）
 */

interface Props {
  /** 提示文案，如「暂无商品」「暂无推荐内容」 */
  text?: string;
  /** 图标尺寸（px），默认 64 */
  size?: number;
  /** 文案颜色，默认浅灰 */
  textColor?: string;
  /** 外层额外样式 */
  className?: string;
  /** 外层额外行内样式 */
  style?: React.CSSProperties;
}

export default function EmptyState({
  text = "暂无数据",
  size = 64,
  textColor = "#9CA3AF",
  className = "",
  style,
}: Props) {
  return (
    <div
      className={`flex flex-col items-center justify-center ${className}`}
      style={style}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 120 120"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        {/* 底部椭圆阴影 */}
        <ellipse cx="60" cy="101" rx="34" ry="6" fill="#E5E7EB" opacity="0.7" />

        {/* 盒子主体 */}
        <path
          d="M26 46h68v42a6 6 0 0 1-6 6H32a6 6 0 0 1-6-6V46Z"
          fill="#F3F4F6"
          stroke="#D1D5DB"
          strokeWidth="2.5"
          strokeLinejoin="round"
        />

        {/* 盒盖（上沿） */}
        <path
          d="M22 34h76a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H22a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2Z"
          fill="#E5E7EB"
          stroke="#D1D5DB"
          strokeWidth="2.5"
          strokeLinejoin="round"
        />

        {/* 盖子与盒身之间的分隔线 */}
        <path
          d="M30 46h60"
          stroke="#D1D5DB"
          strokeWidth="2.5"
          strokeLinecap="round"
        />

        {/* 盒身内的两个小圆点（暗示空的容器） */}
        <circle cx="50" cy="68" r="3" fill="#D1D5DB" />
        <circle cx="70" cy="68" r="3" fill="#D1D5DB" />

        {/* 左上方飘起的小星 */}
        <path
          d="M40 22l1.6 4.4L46 28l-4.4 1.6L40 34l-1.6-4.4L34 28l4.4-1.6L40 22Z"
          fill="#FCD9B6"
        />

        {/* 右上方小星 */}
        <path
          d="M82 18l1.2 3.3 3.3 1.2-3.3 1.2L82 27l-1.2-3.3L77.5 22.5l3.3-1.2L82 18Z"
          fill="#FDE7CF"
        />
      </svg>

      {text && (
        <span
          style={{ color: textColor, fontSize: 13, marginTop: 2 }}
        >
          {text}
        </span>
      )}
    </div>
  );
}
